import DOMPurify from 'dompurify';
import MarkdownIt from 'markdown-it';

/**
 * An announcement message as HTML. A small, safe subset of Markdown: **bold**, *italic*, "- "
 * bullets, numbered lists, [text](link), and bare URLs and email addresses made clickable.
 *
 * - html: false — anything typed as HTML is shown as text, never run. DOMPurify sanitizes the
 *   output again as a second line.
 * - breaks: true — a single line break stays a line break, so messages written before formatting
 *   existed still read as typed (blank lines become paragraphs, as they did).
 * - linkify — "Email info@rightinsight.org" becomes a mailto link without any syntax.
 */
const md = new MarkdownIt({ html: false, breaks: true, linkify: true });

/** In-app routes navigate inside the app; anything else opens in a new tab. */
export const isInAppLink = (href) => typeof href === 'string' && href.startsWith('/');

const defaultLinkOpen =
  md.renderer.rules.link_open ||
  ((tokens, idx, options, env, self) => self.renderToken(tokens, idx, options));

md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
  const href = tokens[idx].attrGet('href') || '';
  if (!isInAppLink(href) && !href.startsWith('mailto:')) {
    tokens[idx].attrSet('target', '_blank');
    tokens[idx].attrSet('rel', 'noopener noreferrer');
  }
  return defaultLinkOpen(tokens, idx, options, env, self);
};

export const renderAnnouncementMarkdown = (text) =>
  text ? DOMPurify.sanitize(md.render(text), { ADD_ATTR: ['target', 'rel'] }) : '';
